(function agencyPlusResponsablePage() {
  $(() => {
    const FOCUSABLE_SELECTORS = 'a[href], button:not([disabled]), [tabindex="0"]';
    const KEYCODES = {
      ESC: 27,
      ENTER: 13,
      TAB: 9,
    };

    const $body = $('body');
    const $header = $('#header-anchor');
    const $banner = $('.comp-message-banner');
    const $nav = $('.cetelem-plus-responsables nav');
    const $main = $('.cetelem-plus-responsables');
    const $navEngagements = $('.cetelem-plus-responsables .nav-engagements');
    const $overlay = $('.cetelem-plus-responsables .overlay');
    const $firstEngagement = $('#first-engagement');
    const $secondEngagement = $('#second-engagement');
    const $thirdEngagement = $('#third-engagement');
    const $fourthEngagement = $('#fourth-engagement');
    const $fifthEngagement = $('#fifth-engagement');
    const $sixthEngagement = $('#sixth-engagement');
    const $seventhEngagement = $('#seventh-engagement');
    const $pourNous = $nav.find('a.pour-nous');
    const $pourTous = $nav.find('a.pour-tous');
    const $pourVous = $nav.find('a.pour-vous');
    const $footer = $('#footer-anchor');

    let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let currentNavState = false;
    let currentRightNavState = false;
    let opener = null;

    let padding = w < 1024 ? 70 : 85;
    let mainNavHeight = $header.outerHeight() + ($('.comp-message-banner').outerHeight() || 0);
    let bothNavHeight = mainNavHeight + $nav.outerHeight();
    let right = (w - $main.width()) / 2 + padding;

    function closePopin() {
      setTimeout(function () {
        $overlay.removeClass('active');

        $popin = $('.cetelem-plus-responsables .popin');
        $popin.removeClass('active');
        $popin.attr('aria-hidden', 'true');

        $body.removeClass('inactive');

        if (opener !== null) {
          opener.trigger('focus');
          opener = null;
        }
      }, 300);
    }

    function trapFocus(element) {
      let focusable = element.find(FOCUSABLE_SELECTORS),
        start_ = focusable[0],
        end_ = focusable[focusable.length - 1];
      element.attr('tabindex') === undefined ? start_.focus() : element.focus();
      element.unbind('keydown').bind('keydown', function (event) {
        if (event.keyCode === KEYCODES.TAB) {
          if (start_ === end_) {
            event.preventDefault();
            start_.focus();
          }
          if (event.shiftKey && document.activeElement === start_) {
            event.preventDefault();
            end_.focus();
          }
          if (!event.shiftKey && document.activeElement === end_) {
            event.preventDefault();
            start_.focus();
          }
        } else if (event.keyCode === KEYCODES.ENTER) {
          if ($(event.target).hasClass('close')) {
            event.preventDefault();
            closePopin();
          }
        }
      });
    }

    $('.cetelem-plus-responsables .open-popin').on('click', function (e) {
      e.preventDefault();

      const popinId = $(this).attr('data-popin');
      const $popin = $(popinId);

      $body.addClass('inactive');
      $overlay.addClass('active');

      $popin.css('height', 'calc(100% - ' + mainNavHeight + 'px)');
      $popin.addClass('active');
      $popin.attr('aria-hidden', 'false');
      $popin.find('.popin-content').trigger('focus');

      trapFocus($popin);

      opener = $(e.target);
      window.location.hash = popinId;

      return false;
    });

    $('.cetelem-plus-responsables .overlay, .cetelem-plus-responsables .popin .close').on(
      'click',
      function (e) {
        e.preventDefault();
        closePopin();
        return false;
      },
    );

    $(document).on('keydown', function (event) {
      if (event.keyCode === KEYCODES.ESC) {
        event.preventDefault();
        closePopin();
      }
    });

    new ResizeObserver(() => {
      currentRightNavState = false;
      w = $(window).width();
      padding = w < 1009 ? 70 : 85;
      mainNavHeight = $header.outerHeight() + ($banner.outerHeight() || 0);
      bothNavHeight = mainNavHeight + $nav.outerHeight();
      right = (w - $main.width()) / 2 + padding;
    }).observe(document.body);

    window.addEventListener('scroll', function (event) {
      const currentTop = $(document).scrollTop();
      const top =
        parseInt($('.cetelem-plus-responsables .home').offset().top) +
        parseInt($('.cetelem-plus-responsables .home H1').outerHeight()) +
        18;
      const startNav = $firstEngagement.offset().top - bothNavHeight;
      const footerTop = $footer.offset().top;

      let endNav = footerTop - $nav.outerHeight() - parseInt($nav.css('top'));

      if (currentTop > top && currentTop <= endNav) {
        if (currentNavState == false) {
          currentNavState = true;
          $nav.addClass('active');
          $nav.css('top', mainNavHeight + 'px');
        }
      } else {
        if (currentNavState == true) {
          currentNavState = false;
          $nav.removeClass('active');
          $nav.css('top', 'initial');
        }
      }

      endNav =
        footerTop - $navEngagements.outerHeight() - parseInt($navEngagements.css('margin-top'));

      if (currentTop >= startNav + 140 && currentTop <= endNav) {
        if (currentRightNavState == false) {
          currentRightNavState = true;
          $navEngagements.css('top', '13px');
          $navEngagements.css('right', right + 'px');
          $navEngagements.addClass('active');
        }
      } else {
        if (currentRightNavState == true) {
          currentRightNavState = false;
          $navEngagements.css('top', 'initial');
          $navEngagements.css('right', padding + 'px');
          $navEngagements.removeClass('active');
        }
      }

      $a = $nav.find('a');
      $a.removeClass('inactive');
      $a.removeClass('active');

      if (currentTop >= startNav) {
        if (
          currentTop >= $seventhEngagement.offset().top - mainNavHeight - padding ||
          window.innerHeight + window.pageYOffset >= document.body.offsetHeight
        ) {
          $pourNous.addClass('active');
          $pourTous.addClass('inactive');
          $pourVous.addClass('inactive');
        } else if (currentTop >= $sixthEngagement.offset().top - mainNavHeight - padding) {
          $pourTous.addClass('active');
          $pourVous.addClass('inactive');
          $pourNous.addClass('inactive');
        } else {
          $pourVous.addClass('active');
          $pourTous.addClass('inactive');
          $pourNous.addClass('inactive');
          $nav.addClass('anchored');
        }
      } else {
        $nav.removeClass('anchored');
      }

      $navEngagements.find('a').removeClass('active');

      if (
        currentTop >= parseInt($seventhEngagement.offset().top - bothNavHeight) ||
        window.innerHeight + window.pageYOffset >= document.body.offsetHeight
      ) {
        $('.cetelem-plus-responsables .nav-engagements a.seventh').addClass('active');
      } else if (currentTop >= parseInt($sixthEngagement.offset().top - bothNavHeight)) {
        $('.cetelem-plus-responsables .nav-engagements a.sixth').addClass('active');
      } else if (currentTop >= parseInt($fifthEngagement.offset().top - bothNavHeight)) {
        $('.cetelem-plus-responsables .nav-engagements a.fifth').addClass('active');
      } else if (currentTop >= parseInt($fourthEngagement.offset().top - bothNavHeight)) {
        $('.cetelem-plus-responsables .nav-engagements a.fourth').addClass('active');
      } else if (currentTop >= parseInt($thirdEngagement.offset().top - bothNavHeight)) {
        $('.cetelem-plus-responsables .nav-engagements a.third').addClass('active');
      } else if (currentTop >= parseInt($secondEngagement.offset().top - bothNavHeight)) {
        $('.cetelem-plus-responsables .nav-engagements a.second').addClass('active');
      } else if (currentTop >= parseInt($firstEngagement.offset().top - bothNavHeight)) {
        $('.cetelem-plus-responsables .nav-engagements a.first').addClass('active');
      }
    });

    $('img.svg').each(function () {
      const $img = $(this);
      const imgID = $img.attr('id');
      const imgClass = $img.attr('class');
      const imgURL = $img.attr('src');

      $.get(
        imgURL,
        function (data) {
          let $svg = $(data).find('svg');

          if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
          }
          if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
          }

          $svg = $svg.removeAttr('xmlns:a');

          $img.replaceWith($svg);
        },
        'xml',
      );
    });

    const hash = $(location).prop('hash');
    if ($(hash).hasClass('popin')) {
      $body.addClass('inactive');
      $overlay.addClass('active');

      $(hash).css('height', 'calc(100% - ' + mainNavHeight + 'px)');
      $(hash).addClass('active');
      $(hash).attr('aria-hidden', 'false');

      opener = $(hash + '_opener');
    }

    const lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));
    const lazyBackgroundImages = [].slice.call(document.querySelectorAll('[lazy-background]'));

    if ('IntersectionObserver' in window) {
      let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove('lazy');
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

      lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });

      let lazyBackgroundImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const lazyBackgroundImage = entry.target;
            lazyBackgroundImage.style.backgroundImage =
              "url('" + lazyBackgroundImage.getAttribute('lazy-background') + "')";
            lazyImageObserver.unobserve(lazyBackgroundImage);
          }
        });
      });

      lazyBackgroundImages.forEach(function (lazyBackgroundImage) {
        lazyBackgroundImageObserver.observe(lazyBackgroundImage);
      });
    }

    $('.cetelem-plus-responsables .loading').css('display', 'none');
  });
})();
